/**
 * Calculates monthly amount in given interval.
 *
 * @param {object} price Stripe price object.
 * @returns {number}     Monthly amount.
 */
export const calculateMonthlyAmount = (price) => {
    // TODO: we shouldn't use fixed values like "year" in code
    return 'year' === price.recurring.interval
        ? Math.round(price.unitAmount / 12)
        : price.unitAmount;
};

/**
 * Calculates annual amount in given interval.
 *
 * @param {object} price Stripe price object.
 * @returns {number}     Annual amount.
 */
export const calculateAnnualAmount = (price) => {
    // TODO: we shouldn't use fixed values like "month" in code
    return 'month' === price.interval ? price.unitAmount * 12 : price.unitAmount;
};

/**
 * Calculates saving percentage for given price.
 *
 * @param {object} price        Stripe price object.
 * @param {object} monthlyPrice Stripe monthly price object.
 * @returns {number}            Precentage saving relative to monthly price.
 */
export const calculatePercentageSaving = (price, monthlyPrice) => {
    if ('year' !== price.recurring.interval) {
        return null;
    }

    const monthlyPerYear = monthlyPrice * 12;

    return Math.round((monthlyPerYear - price.unitAmount) * 100 / monthlyPerYear);
};
